import { TableColumnInfo } from "@/Common/Models/UI/Tables/ColumnConfigurationModel";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { BaseAction } from "@/Common/Stores/Actions/BaseAction";
import { IListModel } from "@/Lists/Models/UI/IListModel";
import { IListsTabModel } from "@/Lists/Models/UI/IListsTabModel";

class ListsAction extends BaseAction {
    public editAnItemOfWaitingList(itemId: string, comments: string, priority: number): void {
        var requestData = {
            ItemId: itemId,
            Priority: priority,
            Comments: comments
        };
        this.Execute(ServerOperations.Server.Myle_EditAnItemOfWaitingList, requestData);
    }

    public checkIfSelectedPatientExists(listId: string, patientId: string): void {
        var requestData = {
            ClinicalWaitingListId: listId,
            PatientId: patientId
        };
        this.Execute(ServerOperations.Server.Myle_CheckIfSelectedPatientExists, requestData);
    }

    public addNewItemToWaitingList(listId: string, patientId: string, comments: string, priority: number): void {
        var requestData = {
            ClinicalWaitingListId: listId,
            PatientId: patientId,
            Priority: priority,
            Comments: comments
        };
        this.Execute(ServerOperations.Server.Myle_AddNewItemToWaitingList, requestData);
    }

    public deleteList(listId: string): void {
        var requestData = {
            ClinicalWaitingListId: listId
        };
        this.Execute(ServerOperations.Server.Myle_DeleteClinicalWaitingList, requestData);
    }

    public removeItemFromList(listId: string, patientId: string): void {
        var requestData = {
            ClinicalWaitingListId: listId,
            PatientId: patientId
        };
        this.Execute(ServerOperations.Server.Myle_DeleteItemFromClinicalWaitingList, requestData);
    }

    public editListName(model: IListModel, listNewName: string): void {
        var requestData = {
            ClinicalWaitingListId: model.get("ListId"),
            ClinicalWaitingListNewName: listNewName
        };
        this.Execute(ServerOperations.Server.Myle_EditClinicalWaitingListName, requestData);
    }

    public searchListItems(model: IListModel): void {
        var requestData = {

            ClinicalWaitingListId: model.get("ListId"),
            SearchString: model.get("GlobalSearchText"),
            OrderBy: model.get("OrderByColumn"),
            OrderDirection: model.get("OrderByDirection"),
            PageSize: model.get("SelectedPageSizeOption"),
            PageNumber: model.get("SelectedPageNumber")
        };

        this.Execute(ServerOperations.Server.Myle_SearchClinicalWaitingListItems, requestData);
    }

    public addNewList(employeeId: string, newListName: string): void {
        var requestData = {
            EmployeeId: employeeId,
            Name: newListName
        };

        this.Execute(ServerOperations.Server.Myle_AddNewClinicalWaitingList, requestData);
    }

    public loadLists(model: IListsTabModel): void {
        const requestData = {
            SearchText: model.get("SearchText"),
            PageSize: model.get("PageSize")
        };
        this.Execute(ServerOperations.Server.Myle_LoadClinicalWaitingLists, requestData);
    }

    public onPrintButtonClickAction(model: IListModel, columnsList: TableColumnInfo[], phoneValidationRuleId: string): void {
        let requestData =
        {
            ClinicalWaitingListId: model.get("ListId"),
            SearchString: model.get("GlobalSearchText"),
            OrderBy: model.get("OrderByColumn"),
            OrderDirection: model.get("OrderByDirection"),
            ColumnHeadersList: columnsList,
            PhoneValidationRule: phoneValidationRuleId
        };

        this.Execute(ServerOperations.Server.Myle_Lists_GeneratePDF, requestData);
    }
}

export { ListsAction };
